import { Spin, Tabs } from 'antd';
import { Fragment, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { APP_ROUTES } from '../../contants/routes';
import { getReportApplicationLinkEffect } from '../../redux/auth/AuthEffects';
import { setAppLoader } from '../../redux/common/CommonActions';
import { routeFileSelector } from '../../utilz/i18n';
import { NOTIFICATION_TYPES, showNotification } from '../components/Modals/notification';
import ClaimsSettingsPage from '../pages/Claims/ClaimsSettingsPage';
import LossAndDamageClaimsPage from '../pages/Claims/LossAndDamageClaimsPage';
import OverChargeClaimsPage from '../pages/Claims/OverChargeClaimsPage';
import CreatePreClaimsScreen from '../screens/Claims/PreClaims/CreatePreClaimsScreen';

const MainRoutes = [
  APP_ROUTES.PRE_CLAIMS,
  APP_ROUTES.OVERCHARGE_CLAIMS,
  APP_ROUTES.LOSS_AND_DAMAGE_CLAIMS,
  APP_ROUTES.CLAIMS_SETTINGS,
  APP_ROUTES.CLAIMS_REPORTS,
];

const ClaimsLayout = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { menus } = useSelector((state) => state.auth);

  const { pathname: activeTab } = useLocation();
  const namespace = useMemo(() => routeFileSelector(activeTab), [activeTab]);
  const { t } = useTranslation([namespace, 'translation']);

  const openClaimsReport = async () => {
    try {
      dispatch(setAppLoader(true));
      const claimsReportLink = menus?.data?.find((item) => item.menuName === 'iClaimReports');

      const { data: claimReportUrl } = await getReportApplicationLinkEffect(claimsReportLink?.navigationID);
      if (!claimReportUrl) {
        throw 'Claims report is not enabled for this Account';
      }
      window.open(claimReportUrl);
      dispatch(setAppLoader(false));
    } catch (error) {
      dispatch(setAppLoader(false));
      showNotification({
        type: NOTIFICATION_TYPES.ERROR,
        message: typeof error === 'string' ? error : 'Failed to get claims report link.',
      });
    }
  };

  const handleNavigation = (key) => {
    if (key === APP_ROUTES.CLAIMS_REPORTS) {
      openClaimsReport();
    } else {
      navigate(key);
    }
  };

  const tabItems = useMemo(
    () => [
      {
        key: APP_ROUTES.PRE_CLAIMS,
        label: t('translation:claims.preClaims'),
        children: <CreatePreClaimsScreen />,
      },
      {
        key: APP_ROUTES.LOSS_AND_DAMAGE_CLAIMS,
        label: t('translation:claims.lossAndDamage'),
        children: <LossAndDamageClaimsPage />,
      },
      {
        key: APP_ROUTES.OVERCHARGE_CLAIMS,
        label: t('translation:claims.overCharge'),
        children: <OverChargeClaimsPage />,
      },
      {
        key: APP_ROUTES.CLAIMS_SETTINGS,
        label: t('translation:claims.claimsSettings'),
        children: <ClaimsSettingsPage />,
      },
      {
        key: APP_ROUTES.CLAIMS_REPORTS,
        label: (
          <Spin spinning={menus.progressing} size="small">
            {t('translation:claims.reports')}
          </Spin>
        ),
        children: <Fragment />,
        disabled: menus.progressing,
      },
    ],
    [menus.progressing, t],
  );

  return (
    <>
      <Tabs
        className={`page-level-tab-container ${!MainRoutes.includes(location?.pathname) ? 'h-auto' : ''}`}
        onChange={handleNavigation}
        activeKey={location?.pathname}
        items={tabItems}
        destroyInactiveTabPane
      />
      <Outlet />
    </>
  );
};

export default ClaimsLayout;
